<template>
  <div>
    <div class="soc-top">
      <div class="soc-Title">SOC</div>
      <div class="top-bottom DS-Digital-Bold">{{target[0].soc}}%</div>
    </div>
    <div class="com-soc">
      <div class="p-content">
        <div
          v-for="(item, i) in loadList1"
          :key="'loadList' + i"
          class="load-list"
        >
          <div class="flex item-t">
            <!-- <div class="icon-bg flex justify-center align-center">{{ i + 1 }}</div> -->
            <div>{{ item.ip }}</div>
            <div class="item-r">{{ item.num }}</div>
          </div>
          <div class="flex item-b align-center">
            <div class="flex1 item-l">
              <!-- <div class="solid" :style="{ width: `${item.num / 2}%` }"></div> -->
              <div class="solid"></div>
            </div>
            <!-- <div class="flexs flex justify-center item-r">{{ item.num }}% </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import myEchart from "./charts/echarts"
import { dataInterface } from "@/api/dataInterfaceApi";
import { formatTime } from "@/utils/index";
export default {
  components: {},
  data() {
    return {
      target: [
        {
          soc: "",
        },
      ],
      subTitleAt: 0,
      loadList1: [
        {
          ip: "有功功率(KW)",
          num: "",
        },
        {
          ip: "可用充电量(KWh)",
          num: "",
        },
        {
          ip: "日充电量(KWh)",
          num: "",
        },
        {
          ip: "累计充电量(KWh)",
          num: "",
        },
      ],
    };
  },
  destroyed() {
		this.$bus.$off('bigScreen::storedEnergyId')
	},
	mounted() {
    this.$bus.$on('bigScreen::storedEnergyId', ()=>{
			this.soc()
		})
		this.soc()
  },
  methods: {
    soc() {
      let params1 = {
        enCode: "chuneng-quanguo-yxxx",
        "@energyId": localStorage.getItem('bigScreen::storedEnergyId') || "ES00001",
      };
      dataInterface
        .dataFaceApi(params1)
        .then((res) => {
          let data1 = res[0] || {};
          this.loadList1[0].num = data1.charge_power || 0;
          this.loadList1[1].num = data1.charge_elect || 0;
          this.loadList1[2].num = data1.day_charge_elect || 0;
          this.loadList1[3].num = data1.acc_charge_elect || 0;
          this.target[0].soc = data1.soc || 0;
          // console.log(res, this.target[0].soc, data1.soc, "soc");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 副标题切换
    subTitleChange(i) {
      this.subTitleAt = i;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/components/energyStorage/comm.scss";
.soc-top {
  background: url(~@/assets/images/exposition/01.png) center no-repeat;
  background-size: 100%;
  width: 230px;
  height: 120px;
  margin: 0 auto;
  margin-top: 30px;
  position: relative;
  .top-bottom {
    position: absolute;
    top: -7px;
    left: 80px;
    font-size: 36px;
    color: #31c6c9;
    text-align: center;
  }
  .soc-Title {
    font-size: 22px;
    position: absolute;
    top: -32px;
    left: 88px;
  }
}

.com-soc {
  width: 100%;
  height: 200px;
  .sub-title {
    font-size: 20px;
    // padding-top: 20px;
    // height: 50px;
    > div {
      padding-right: 20px;
      > p {
        text-shadow: 0px 0px 9px #03b9bd;
        // padding: 0 10px;
        position: relative;
        cursor: pointer;
        &.at {
          &::after {
            position: absolute;
            bottom: -10px;
            left: 0;
            content: "";
            width: 100%;
            height: 2px;
            background: linear-gradient(
              270deg,
              rgba(113, 186, 188, 0.0001) 0%,
              #71bbbd 33.33%,
              #6db5b7 66.67%,
              rgba(111, 185, 187, 0.0001) 100%
            );
          }
        }
      }
    }
  }

  .p-content {
    width: 100%;
    height: 200px;
    padding-right: 8px;
    // padding-left: 8px;
    box-sizing: border-box;
    .load-list {
      font-size: 20px;
      margin-bottom: 25px;
      .item-t {
        justify-content: space-between;
        .icon-bg {
          width: 36px;
            width: 100px;
          // height: 42px;
          // background: url(~@/assets/images/computility/dispatch-icon6.png) center no-repeat;
          background-size: 100%;
          // padding-bottom: 6px;
          box-sizing: border-box;
          font-size: 20px;
          margin-right: 20px;
        }
        .item-r {
          color: #31c6c9;
          font-family: "HT";
          font-size: 26px;
        
        }
      }
      .item-b {
        // margin-top:5px ;
        // height: 50px;
        .item-l {
          height: 3px;
          background-color: rgba(208, 222, 238, 0.1);
          .solid {
            background: linear-gradient(
              270deg,
              #31c6c9 1.64%,
              #17797a 40%,
              #054041 100%
            );
            position: relative;
            height: 7px;
            // &::before {
            // 	position: absolute;
            // 	content: '';
            // 	background-color: #fff;
            // 	box-shadow: 0px 0px 4px 0px #EFD48E;
            // 	width: 18px;
            // 	height: 18px;
            // 	right: -9px;
            // 	top: -3px;
            // 	border-radius: 50%;
            // }
          }
        }
      }
    }
    .load-list:nth-child(2) {
      .item-t {
        .item-r {
          color: #ffd15c;
        }
      }
      .item-b {
        .item-l {
          .solid {
            background: linear-gradient(
              270deg,
              #ffd15c 1.64%,
              #805e0b 40%,
              #553d05 100%
            );
          }
        }
      }
    }
    .load-list:nth-child(4) {
      .item-t {
        .item-r {
          color: #ffd15c;
        }
      }
      .item-b {
        .item-l {
          .solid {
            background: linear-gradient(
              270deg,
              #ffd15c 1.64%,
              #805e0b 40%,
              #553d05 100%
            );
          }
        }
      }
    }
  }
}
</style>